import VereficationStatus from "modules/shared/profiles/VereficationStatus";
import React from "react";
import styled from "styled-components";

const ModalHeader = ({ entityName, entityId, entityStatus }) => {
    const EntityName = styled.div`
        display: flex;
        width: 40%;
        justify-content: space-between;
        align-items: center;
        padding-block: 30px;
    `;
    const EntityId = styled.span`
        color: #006bb4;
    `;

    return (
        <EntityName>
            {entityName}
            <EntityId>{entityId}#</EntityId>
            <VereficationStatus status={entityStatus} />
        </EntityName>
    );
};

export default ModalHeader;
